import '../interactiveMap.css'
import React, { Component } from "react"
import PropTypes from 'prop-types'
import request from "axios"   
import Maps from './Maps';
import {Ep2019ListConfig} from '../../public/ep2019_listconfig.js';
class App extends Component {
   constructor(props){
      super(props);
      this.branches = [
         {id:'europee', title:'Circoscrizioni Europee', tabLabel:'Europee'},
      ]
      this.state={
         activeBranch:null,
         title:'',
         enableToggle:false,
         width: window.innerWidth
      }
   }
   getChildContext() {
      return {
         lists: Ep2019ListConfig
      };
   }
   componentWillMount() {
      window.addEventListener('resize', this.handleWindowSizeChange);
   }
   componentWillUnmount() {
      window.removeEventListener('resize', this.handleWindowSizeChange);
   }
   componentDidMount(){
      // setup app wrapper
      const title = this.branches[0].title;
      const enableToggle = this.props.enableToggle ? true : false;
      this.setState({
         activeBranch: this.props.branch,
         title,
         enableToggle
      })
   }
   toggleBranch(isTabActive){
      if(!isTabActive){
         this.setState(()=>{
            return {
               activeBranch : this.branches[0].id,
               title : this.branches[0].title
            }
         })
      }
   }
   renderToggle(){
      if(this.state.enableToggle){
         const {activeBranch, title} = this.state;
         return (
            <div className="toogleBranch">
               {this.branches.map( branch => {
                  const isTabActive = activeBranch === branch.id;
                  return(
                     <span 
                     key={branch.id} 
                     className={isTabActive ? 'toggleTab active' : 'toggleTab'}
                     onClick={()=>this.toggleBranch(isTabActive)}>
                     {branch.title}
                     </span>
                  )}
               )}
            </div>
         )
      }else{
         return <h2>{this.state.title}</h2>
      }
   }
   handleWindowSizeChange = () => {
      this.setState({ width: window.innerWidth });
   };
   render() {
      return (
         <div className="ep2019-interactive-map ep19im">
            {this.renderToggle()}
            {this.state.activeBranch && 
            <Maps 
               branch={this.state.activeBranch}
               remotePath={this.props.path}
               mapPath={this.props.mapPath}
               logoPath={this.props.logoPath}
               isNarrowWidth={this.state.width<=700}
            />
            }
         </div>
      );
   }
}
App.childContextTypes = {
   lists: PropTypes.object
};
export default App;



// WEBPACK FOOTER //
// ./src/components/App.js